<template>
  <v-app>
    <v-container grid-list-md>
      <v-layout row wrap>
        <v-flex xs12 lg6>
          <v-select
            :items="employmentStatus"
            :attach="true"
            item-text="text"
            item-value="key"
            v-model="officialItem.employment_status"
            v-on:input="changeEvent"
            :readonly="isView"
            label="貸款者就業狀態"
          ></v-select>
        </v-flex>
      </v-layout>
      <!-- <v-layout row wrap>
        <v-flex xs12 lg6>
          <v-text-field
            v-model="officialItem.itemInfo.vendor"
            label="廠牌"
            v-on:input="changeEvent"
          ></v-text-field>
        </v-flex>
        <v-flex xs12 lg6>
          <v-text-field
            v-model="officialItem.itemInfo.name"
            label="車名"
            v-on:input="changeEvent"
          ></v-text-field>
        </v-flex>
      </v-layout>
      <v-layout row wrap>
        <v-flex xs12 lg6>
          <v-text-field
            v-model="officialItem.itemInfo.publicYear"
            label="出廠年"
            v-on:input="changeEvent"
          ></v-text-field>
        </v-flex>
        <v-flex xs12 lg6>
          <v-text-field
            v-model="officialItem.itemInfo.publicMonth"
            label="出廠月"
            v-on:input="changeEvent"
          ></v-text-field>
        </v-flex>
      </v-layout>
      <v-layout row wrap>
        <v-flex xs12 lg6>
          <v-text-field
            v-model="officialItem.itemInfo.carId"
            label="車號"
            v-on:input="changeEvent"
          ></v-text-field>
        </v-flex>
        <v-flex xs12 lg6>
          <v-text-field
            v-model="officialItem.itemInfo.cc"
            label="CC"
            v-on:input="changeEvent"
          ></v-text-field>
        </v-flex>
      </v-layout> -->
      <v-layout>
        <v-flex>
          <v-btn class="success" dark text @click="searchBankInfo"
            >全台銀行代碼及分行表</v-btn
          >
        </v-flex>
      </v-layout>
      <v-layout row wrap>
        <v-flex xs6>
          <v-autocomplete
            :items="getBankInfo"
            :attach="true"
            item-text="branch"
            item-value="key"
            v-model="officialItem.bankId"
            :readonly="isView"
            @change="changeEvent"
            :label="`撥款銀行代碼`"
          ></v-autocomplete>
        </v-flex>
        <v-flex xs6>
          <v-autocomplete
            :items="getBankSubInfo"
            :attach="true"
            item-text="branch"
            item-value="code"
            v-model="officialItem.bankSubId"
            :readonly="isView"
            @change="changeEvent"
            label="撥款銀行分行代碼"
          ></v-autocomplete>
        </v-flex>
      </v-layout>
      <v-layout>
        <v-flex xs12>
          <v-text-field
            v-model="officialItem.bankAccount"
            :label="`撥款帳號`"
            placeholder="輸入正確的帳號"
            :readonly="isView"
            v-on:input="changeEvent"
          ></v-text-field>
        </v-flex>
      </v-layout>

      <v-layout row wrap v-if="!isView">
        <v-flex xs12 lg12>
          <v-select
            :items="caseTypeList"
            :attach="true"
            item-text="text"
            item-value="key"
            v-model="busType"
            label="貸款文件相關圖檔"
            v-on:change="changeRoute"
          ></v-select>
          <!-- <select v-model="busType">
              <option v-for="caseTypeItem in caseTypeList" :key="caseTypeItem.key" :value="caseTypeItem.text">{{caseTypeItem.text}}</option>
        </select> -->
        </v-flex>
        <v-flex xs12 lg12>
          <v-container>
            <v-layout row wrap>
              <v-flex xs12 md12>
                <div class="dropbox">
                  <input
                    type="file"
                    ref="file"
                    multiple
                    @change="
                      filesChange($event.target.name, $event.target.files)
                    "
                    accept="image/*"
                    class="input-file"
                  />
                  <p>
                    將圖片拖到此處
                    <br />或點擊
                  </p>
                </div>
              </v-flex>
            </v-layout>
          </v-container>
        </v-flex>
      </v-layout>
      <v-layout v-if="uploadedFiles.length > 0" row wrap>
        <v-flex xs12 md12>
          <v-card>
            <v-container fluid grid-list-md>
              <v-layout row wrap>
                <v-flex
                  v-for="file in uploadedFiles"
                  :key="`${file.imageId}`"
                  v-bind="{ [`xs3`]: true }"
                >
                  <v-card>
                    <v-img :src="file.data" height="200px" contain> </v-img>
                    <v-card-actions>
                      <v-layout fill-height>
                        <v-flex xs12>
                          <span v-text="file.name"></span>
                        </v-flex>
                      </v-layout>
                      <v-spacer></v-spacer>
                      <!-- 
                    <v-btn icon @click="editImage(file)">
                      <v-icon large color="indigo darken-2">edit</v-icon>
                    </v-btn>-->
                    <v-btn v-if="!isView" icon @click="removeImage(file.imageId)">
                      <v-icon large color="red darken-2">delete</v-icon>
                    </v-btn> 
                    </v-card-actions>
                  </v-card>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card>
        </v-flex>
      </v-layout>

      <alert-view :visible="messageDialog.visible"
                  :title="messageDialog.title"
                  :content="messageDialog.text"
                  @confirmEvent="messageDialog.confirm">
                </alert-view>
    </v-container>
  </v-app>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import UseCaseModel from "../models/UseCaseFileModel";
import LaonhfcModel from "../models/LaonhfcModel";
import { ResizeImage } from "../pages/utils/tool";
import AlertView from '@/components/AlertView';

const bankCodeList = require('../assets/bank_data.json');

export default {
  props: {
    itemDetail: Object,
    isView: Boolean,
  },
  name: "UseCaseView",
  components:{
    AlertView
  },
  data() {
    return {
      bankCodeList: bankCodeList,
      uploadedFiles: [],
      busType: "",
      messageDialog: {
        title: "",
        text: "",
        visible: false,
        showCancel: false,
        confirm: () => {},
        cancel: () => {},
      },
      officialItem: {
        bankId: "",
        bankSubId: "",
        bankAccount: "",
        employment_status: 0,
        itemInfo: new LaonhfcModel(),
      },
    };
  },
  created() {
     if (this.itemDetail.laonhfcInfo) {
      this.officialItem.itemInfo = this.itemDetail.laonhfcInfo;
    }
    if (this.itemDetail.files.length > 0) {
      this.itemDetail.files.forEach(item => {
        console.log(`item ${JSON.stringify(item)}`)
        if(!item.imageId) {
          item.imageId = Math.uuidFast();
        }
        this.uploadedFiles.push(item);
      })
      this.uploadedFiles = this.itemDetail.files;
    }
    if (this.itemDetail.bankId) {
      this.officialItem.bankId = this.itemDetail.bankId;
    }
    if (this.itemDetail.bankSubId) {
      this.officialItem.bankSubId = this.itemDetail.bankSubId;
    }
    if (this.itemDetail.bankAccount) {
      this.officialItem.bankAccount = this.itemDetail.bankAccount;
    }
    if (this.itemDetail.useCase.employment_status) {
      this.officialItem.employment_status = this.itemDetail.useCase.employment_status;
    }
  },
  mounted() {
   
  },
  computed: {
    caseTypeList() {
      
      let typeList = [
        { key: "LDR23", text: "申請人申請書" },	// 必填
        { key: "LDR1", text: "申請人身分證正面" }, // 必填
        { key: "LDR2", text: "申請人身分證反面" }, // 必填
        { key: "LDR3", text: "申請人身撥款帳戶存摺封面" }, // 必填
        { key: "LDR24", text: "申請人薪轉存摺封面" },
        { key: "LDR14", text: "申請人薪轉存摺內頁" },
        { key: "LDR19", text: "申請人勞保證明" },
        { key: "LDR4", text: "申請人機車行照" },
        { key: "LDR5", text: "申請人財力證明" },
        { key: "LDR10", text: "申請人個人JCIC" },
        { key: "LDR9", text: "申請人貸款繳息紀錄" },
        { key: "LDR8", text: "申請人信用卡帳單" },
        { key: "LDR11", text: "申請人地價/房屋稅單或謄本" },
        { key: "LDR7", text: "申請人專業證照" },
        { key: "LDR6", text: "申請人在職證明" },
        { key: "LDR25", text: "申請人財力證明" },
        { key: "GRT1", text: "保證人身分證正面" },
        { key: "GRT2", text: "保證人身分證反面" },
        { key: "GRT15", text: "保證人薪轉存摺封面" },
        { key: "GRT7", text: "保證人薪轉存摺內頁" },
        { key: "GRT11", text: "保證人財力證明" },
        { key: "GRT16", text: "保證人其它資料" },
      ];
      if (this.uploadedFiles.length > 0) {
        this.uploadedFiles.forEach((element) => {
          //  element.code
          let filterArray = this.excludeKey.filter( (key) => 
            key === element.code
            );
          if (filterArray.length === 0) {
            const index = typeList
            .map(function (e) {
              return e.key;
            }).indexOf(element.code);
            console.log(` index === ${index}`);
            if (index > -1) {
              typeList.splice(index, 1);
            }
          }
        });
      }
      return typeList;
    },
    employmentStatus() {
      return [
        { key: 1, text: "就業中" },
        { key: 2, text: "待業中" },
        { key: 3, text: "家管" },
        { key: 4, text: "我是學生有兼差" },
      ];
    },
    getBankInfo() {
      let bankCopyList = JSON.parse(JSON.stringify(this.bankCodeList));      
      let list = [];
      Object.keys(bankCopyList).forEach((key) => {
        const bankInfo = bankCopyList[key];
        bankInfo.branch = `(${key})${bankInfo.branch}`;
        bankInfo.key = key;
        if (bankInfo.child.length > 0) {
          list.push(bankInfo);
        }
      });
      return list;
    },
    getBankSubInfo() {
      let list = [];
      let bankInfo = bankCodeList[this.officialItem.bankId];

      if (bankInfo) {
        bankInfo.child.forEach((info) => {
          let copyItemInfo = {};
          Object.assign(copyItemInfo, info);
          copyItemInfo.branch = `(${info.code})${info.branch}`;
          copyItemInfo.code = info.code.substring(3, info.code.length);
          list.push(copyItemInfo);
        });
      }
      return list;
    },
    excludeKey() {
      return ['LDR14', 'LDR19', 'LDR5', 'LDR25', 'GRT11', 'GRT7', 'LDR9', 'LDR8', 'LDR11', 'LDR7', 'LDR6', 'GRT16']
    }
  },
  methods: {
    changeRoute() {
      this.$refs.file.value = null;
    },
    filesChange(fieldName, fileList) {
      const files = Object.values(this.$refs.file.files);
      if (!fileList.length) return;
      if (!this.busType) {
        this.$refs.file.value = null;
        this.showMessageDialog(
          "錯誤",
          "請選擇貸款文件相關圖檔",
          true,
          () => {},
          () => {}
        );
        return;
      }
      let filterArray = this.excludeKey.filter( (key) => 
            key === this.busType
            );
      if (fileList.length > 1 && filterArray.length === 0) {
        this.$refs.file.value = null;
        this.showMessageDialog(
          "錯誤",
          "只能上傳一張圖",
          true,
          () => {},
          () => {}
        );
        return;
      }
      
      if (this.uploadedFiles.length > 0 && filterArray.length === 0) {
        this.$refs.file.value = null;
        const uploadedFile = this.uploadedFiles.find(
          (item) => item.code === this.busType
        );
        if (uploadedFile) {
          this.showMessageDialog(
            "錯誤",
            "已經有上傳的圖檔",
            true,
            () => {},
            () => {}
          );
          return;
        }
      }
      files.forEach(item => {
        const file = {
            name: item.name,
            image: item,
            size: item.size,
            type: item.type,
          };

        this.createImage(file);
      });
    },
    removeImage(imageId) {
      console.log(JSON.stringify(this.uploadedFiles));
      const copy = JSON.parse(JSON.stringify(this.uploadedFiles));
      copy.forEach((item, index) => {
        if (item.imageId === imageId) {
          this.uploadedFiles.splice(index, 1);
        }
      });
      console.log(JSON.stringify(this.uploadedFiles));
      if (this.uploadedFiles.length === 0) {
        this.$refs.file.value = null;
      }
    },
    createImage(file) {
      const reader = new FileReader();
      const code = this.busType;
      const fileName = this.getFileName();
      const fileSize = file.size;
      const fileType = this.getFileType(file.type);      
      reader.onload = (e) => {
        let data = e.target.result;
        if (fileType === "jpg" || fileType === "png") {
          // 如果大於2MB，進行瘦身
          if (fileSize > 2097152) {
            data = ResizeImage(data);
          }
          let userCaseItem = new UseCaseModel();
          userCaseItem.imageId = Math.uuidFast();
          userCaseItem.code = code;
          // base64 image
          userCaseItem.data = data;
          // 檔案類型
          userCaseItem.type = fileType;
          // 檔案大小
          userCaseItem.size = fileSize;
          // 檔案名稱
          userCaseItem.name = fileName;
          this.uploadedFiles.push(userCaseItem);       
          this.uploadEvent();   
        }
      };
      reader.readAsDataURL(file.image);
    },
    getFileType(type) {
      const name = type.toLowerCase();
      if (name.indexOf("jpeg") > -1 || name.indexOf("jpg") > -1) {
        return "jpg";
      }
      if (name.indexOf("png") > -1) {
        return "png";
      }
      if (name.indexOf("pdf") > -1) {
        return "pdf";
      }
      return "zip";
    },
    getFileName() {
      const itemArray = this.caseTypeList.filter((m) => m.key === this.busType);
      if (itemArray.length > 0) {
        const item = itemArray[0];
        return item.text;
      } else {
        return "";
      }
    },
    showMessageDialog(title, text, visible, confirmEvent, cancelEvent) {
      this.messageDialog.title = title;
      this.messageDialog.text = text;
      this.messageDialog.visible = visible;
      const self = this;
      this.messageDialog.confirm = () => {
        self.messageDialog.visible = false;
        if (confirmEvent) {
          confirmEvent();
        }
      };

      this.messageDialog.cancel = () => {
        self.messageDialog.visible = false;
        if (cancelEvent) {
          cancelEvent();
        }
      };
    },
    
    searchBankInfo() {
      window.open(
        "https://www.banking.gov.tw/ch/home.jsp?id=60&parentpath=0,4&mcustomize=FscSearch_BankType.jsp&type=1",
        "_blank"
      );
    },
    changeEvent() {
      this.$emit("changeEvent", this.officialItem);
    },
    uploadEvent() {
      this.$emit("uploadEvent", this.uploadedFiles);
    },
  },
};
</script>

<style scoped>
.input-file {
  opacity: 0; /* invisible but it's there! */
  width: 100%;
  height: 200px;
  position: absolute;
  cursor: pointer;
}
.dropbox {
  outline: 2px dashed grey; /* the dash box */
  outline-offset: -10px;
  background: white;
  color: dimgray;
  padding: 10px 10px;
  min-height: 200px; /* minimum height */
  position: relative;
  cursor: pointer;
}
.dropbox:hover {
  background: white;
}

.dropbox p {
  font-size: 1.2em;
  text-align: center;
  padding: 50px 0;
}
</style>


// WEBPACK FOOTER //
// src/components/UseCaseView.vue